import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import styles from "./style.module.css";
import Info from "../../../../../../../components/info";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingButton from "../../../../../../../components/loading/button";
import { useTheme } from "../../../../../../../context/themeContext";
import useInfoBoxs from "../../../../../../../hooks/useInfoBoxs";
import { useDispatch, useSelector } from "react-redux";
import { updateSkillData } from "../../../../../../../store/slices/profile/skillSlice";
import useSkill from "../../../../../../../hooks/skills/useSkill";
import moment from "moment";

const EditDescription = () => {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const infoBoxes = useInfoBoxs();
  const { data } = useSelector((state) => state.skill);
  const navigate = useNavigate();
  const { buttonLoading } = useSelector((state) => state.isLoading);
  const user = useSelector((state) => state.user.value);
  const { pathname } = useLocation();
  // useDiscover(true);

  const { editSkill, addSkill } = useSkill();

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Box className={styles.editDescription}>
      <Box
        className={styles.communityStatus}
        sx={{
          alignSelf: {
            xs: "stretch",
          },
        }}
      >
        <Box className={styles.description}>
          <Box className={styles.category}>
            <Typography
              variant="body1"
              color={theme.palette.darkgrey.darkgrey600}
              fontWeight={500}
            >
              Tell everyone about your experience:
            </Typography>
            <TextField
              value={data?.description ? data?.description : ""}
              onChange={(e) => {
                dispatch(updateSkillData({ description: e.target.value }));
              }}
              multiline
              rows={3}
              inputProps={{ maxLength: 500 }}
              fullWidth
              sx={{
                lineHeight: "24px",
              }}
            />
            <Typography
              variant="caption"
              color={
                data?.description?.length > 500 ? "error" : "textSecondary"
              }
              sx={{
                width: "100%",
                textAlign: "right",
              }}
            >
              {data?.description?.length ?? 0}/500 characters
            </Typography>
          </Box>
          <TextField
            label="Portfolio Link"
            value={data?.link ? data?.link : "https://"}
            onChange={(e) =>
              dispatch(updateSkillData({ link: e.target.value }))
            }
            type="url"
            fullWidth
          />
          <Box className={styles.category}>
            <Typography
              variant="body1"
              color={theme.palette.darkgrey.darkgrey600}
              fontWeight={500}
            >
              At what age did you start training in this skill?
            </Typography>
            <TextField
              value={data?.startedTrainingAge ? data?.startedTrainingAge : ""}
              type="number"
              onChange={(e) => {
                const value = +e.target.value;
                const maxStartAge = moment().diff(
                  moment(user?.birthDate),
                  "years"
                );
                if (
                  typeof value === "number" &&
                  value > 0 &&
                  value <= maxStartAge
                )
                  dispatch(
                    updateSkillData({ startedTrainingAge: e.target.value })
                  );
              }}
              sx={{
                width: "30%",
              }}
            />
          </Box>
          <Box className={styles.category}>
            <Typography
              variant="body1"
              color={theme.palette.darkgrey.darkgrey600}
              fontWeight={500}
            >
              How would you assess your skill level?
            </Typography>
            <RadioGroup
              row
              sx={{
                color: theme.palette.darkgrey.darkgrey500,
                "& .css-ahj2mt-MuiTypography-root": {
                  fontSize: "14px",
                },
              }}
              value={data?.level ? data?.level : ""}
              onChange={(e) =>
                dispatch(updateSkillData({ level: e.target.value }))
              }
            >
              <FormControlLabel
                value="Beginner"
                control={<Radio size="medium" />}
                label="Beginner"
                fontSize="14px"
              />
              <FormControlLabel
                value="Intermediate"
                control={<Radio size="medium" />}
                label="Intermediate"
              />
              <FormControlLabel
                value="Advanced"
                control={<Radio size="medium" />}
                label="Advanced"
              />
              <FormControlLabel
                value="Master"
                control={<Radio size="medium" />}
                label="Master"
              />
            </RadioGroup>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              alignSelf: "stretch",
            }}
          >
            <Checkbox
              sx={{ m: "0px", p: "0px" }}
              checked={
                data?.acceptOnlyPaidProject
                  ? data?.acceptOnlyPaidProject
                  : false
              }
              onChange={(e) =>
                dispatch(
                  updateSkillData({
                    acceptOnlyPaidProject: e.target.checked,
                  })
                )
              }
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                alignSelf: "stretch",
              }}
            >
              <Typography
                variant="body2"
                color={theme.palette.darkgrey.darkgrey500}
              >
                I am a professional and I only accept paid market-rate projects.
              </Typography>
              {infoBoxes.map((item) => {
                if (item.name === "pro") {
                  return (
                    <Info
                      heading={item.title}
                      content={item.content}
                      key={item.title}
                    />
                  );
                }
                return null;
              })}
            </Box>
          </Box>
        </Box>
        <Box className={styles.buttons}>
          <Button
            onClick={pathname.includes("add-skill") ? addSkill : editSkill}
            variant="contained"
            fullWidth
            disabled={buttonLoading}
            sx={{
              backgroundColor: buttonLoading && theme.palette.primary.dark,
            }}
          >
            {buttonLoading ? <LoadingButton /> : "Save"}
          </Button>
          <Button
            onClick={handleCancel}
            variant="text"
            fullWidth
            sx={{
              color: theme.palette.darkgrey.darkgrey400,
              textTransform: "capitalize",
              fontSize: "16px",
              fontWeight: "500",
              p: "0px",
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default EditDescription;
